export enum CompensationOption {
  Download = "download",
  ComplimentaryIssue = "complimentary_issue",
  Replacement = "replacement",
}
